import { render, staticRenderFns } from "./MobileList.vue?vue&type=template&id=99dbf0b0&scoped=true&"
import script from "./MobileList.vue?vue&type=script&lang=js&"
export * from "./MobileList.vue?vue&type=script&lang=js&"
import style0 from "./MobileList.vue?vue&type=style&index=0&id=99dbf0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dbf0b0",
  null
  
)

export default component.exports